import React from 'react'
import classes from './UnregisteredMainContent.module.scss'
import { Text } from '@consta/uikit/Text'
import { Button } from '@consta/uikit/Button'
import { useNavigate } from 'react-router-dom'

const UnregisteredMainContent = () => {
    const navigate = useNavigate()

    return (
        <div className={classes.container}>
           <Text size='3xl' style={{ color: '#0078d2' }} weight='bold'>Добро пожаловать в GEOINDICATOR</Text> 
           <Text as='span' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}><Text>Для полного доступа к платформе завершите регистрацию в личном</Text> <Text>кабинете.</Text></Text> 
           <Text view='secondary' as='span' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}><Text>После подтверждения регистрации вы сможете работать с проектами, отчётами и </Text> <Text>данными мониторинга. </Text></Text> 
            <Button size='l' label='Перейти в личный кабинет' onClick={() => navigate('/account')}/>
        </div>
    )
}

export default UnregisteredMainContent